var render = function render(){var _vm=this,_c=_vm._self._c;return _c('web-link',{on:{"input":_vm.emitValue},model:{value:(_vm.webLinkList),callback:function ($$v) {_vm.webLinkList=$$v},expression:"webLinkList"}})
}
var staticRenderFns = []

export { render, staticRenderFns }